import { PropsWithChildren } from "react";
import { CSSObject } from "@emotion/react";
import { MdOutlineError } from "react-icons/md";

import styles from "./ErrorAlert.module.css";

type ErrorAlertProps = {
  customStyles?: CSSObject;
};

export const ErrorAlert: React.FC<PropsWithChildren<ErrorAlertProps>> = ({
  customStyles,
  children,
}) => {
  return (
    <div className={styles.errorBlock} css={customStyles}>
      <MdOutlineError css={{ color: "var(--ion-color-danger)", flexShrink: 0 }} />
      {children}
    </div>
  );
};
